import * as React from 'react';
import { Query } from '@apollo/client/react/components';
import { Button } from 'react-bootstrap';
import SlidingPane from 'react-sliding-pane';
import { ErrorMessage } from '../../../components/ErrorMessage';
import { Loader } from '../../../components/Loader';
import { getStockTotals } from '../api';
import { stockTotalColumns } from '../util';
import ReactTable from 'react-table';

export const StockTotals = (props: any) => {
  const [visible, setVisible] = React.useState(false);

  return (
    // <div style={{ textAlign: 'center' }}>
    <>
      <Button className='mt-3 mb-3 ml-2' variant='danger' onClick={() => setVisible(true)}>
        View Stock Totals
      </Button>

      <SlidingPane
        style={{ zIndex: 50 }}
        isOpen={visible}
        width='450px'
        title='Items Available for Deployment'
        onRequestClose={() => setVisible(false)}>
        <Query query={getStockTotals}>
          {({ loading, error, data }: any) => {
            if (loading) return <Loader />;
            if (error) return <ErrorMessage title='Issue Finding OIT Stock Count Data' />;
            if (data) {
              return (
                <ReactTable
                  columns={stockTotalColumns}
                  pageSize={5}
                  showPagination={false}
                  sortable={false}
                  noDataText='No Data Available'
                  className='-striped -highlight mb-5'
                  data={data.getStockTotals}
                />
              );
            }
            return (
              <div>
                <h2>Null?</h2>
              </div>
            );
          }}
        </Query>
      </SlidingPane>
    </>
  );
};
